import "./styles/styles.scss";
import "./utils/hawkins.utils";
import { GlobalContext, GlobalContextType } from "./utils/GlobalContext.ts";
import { HelmetProvider } from "react-helmet-async";
import { Router } from "./components/utils/Router/Router.tsx";
import { GlobalMetaHelmet } from "./components/utils/GlobalMetaHelmet/GlobalMetaHelmet.tsx";
import { HawkinsProvider } from "@hawkins/components/lib/hawkinsProvider/hawkinsProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const App = ({
  globalContext,
}: {
  globalContext: GlobalContextType;
}) => {
  const queryClient = new QueryClient();

  return (
    <HawkinsProvider theme="dark">
      <GlobalContext.Provider value={globalContext}>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            <GlobalMetaHelmet />
            <Router />
          </QueryClientProvider>
        </HelmetProvider>
      </GlobalContext.Provider>
    </HawkinsProvider>
  );
};
